import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class CartasService {
  constructor(protected http: HttpClient) {}

  public get(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.serverUrl}api/cartas/get`);
  }

  public getHistorial(i: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/cartas/get`,
      {
        params: { i },
      }
    );
  }

  public add(defa: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/cartas/add`,
      defa,
      options
    );
  }
  public getPdf(i: string): Observable<HttpResponse<Blob>> {
    return this.http.get(
      `${environment.serverUrl}api/cartas/pdf`,
      { params: { i }, responseType: "blob", observe: "response" }
    );
  }
}
